export default {
  prefix: 't',
};
